var fragment = {
    type: "color",
    options: {
        colorList: [
            // --colors-green-700
            "#3A8574",
            // --colors-blue-500
            "#004E9C",
            // --colors-orange-700
            "#ED6541",
            // --colors-purple-700
            "#431382"
        ]
    }
};
export default {
    fragment: fragment
};

//# sourceMappingURL=accentColor.js.map